import { Fragment, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ENTITIES = ["transaction", "statement", "party", "ledger", "invoice", "export_batch", "bank_account", "settings", "user", "business", "backup"];

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [entity, setEntity] = useState("");
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/audit", { params: { entity, q } }).then((r) => setLogs(r.data)), 250);
    return () => clearTimeout(t);
  }, [entity, q]);
  return (
    <div>
      <PageHeader title="Audit History" sub="Every change, view of a banking document, approval and export — who, when, before and after. Append-only." />
      <div className="mb-4 flex flex-wrap gap-2">
        <Select value={entity || "all"} onValueChange={(v) => setEntity(v === "all" ? "" : v)}><SelectTrigger className="w-48" data-testid="audit-entity-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All entities</SelectItem>{ENTITIES.map((e) => <SelectItem key={e} value={e}>{e}</SelectItem>)}</SelectContent></Select>
        <Input className="w-64" placeholder="Search action, user, id" value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search-input" />
      </div>
      <div className="panel max-h-[70vh] overflow-auto">
        <table className="w-full min-w-[800px] text-xs">
          <thead className="glass sticky top-0 text-left text-muted-foreground"><tr>{["When (UTC)", "User", "Entity", "Action", "Note"].map((h) => <th key={h} className="p-3 font-medium">{h}</th>)}</tr></thead>
          <tbody>{logs.map((l) => (
            <Fragment key={l.id}>
              <tr className="cursor-pointer border-t transition-colors hover:bg-accent/60" onClick={() => setOpen(open === l.id ? null : l.id)} data-testid="audit-row">
                <td className="num p-3">{l.at.slice(0, 19).replace("T", " ")}</td><td className="p-3">{l.user_name}</td>
                <td className="p-3">{l.entity} <span className="num text-muted-foreground">{l.entity_id?.slice(0, 8)}</span></td>
                <td className="p-3 font-medium">{l.action}</td><td className="max-w-[300px] truncate p-3 text-muted-foreground">{l.note}</td>
              </tr>
              {open === l.id && <tr><td colSpan={5} className="bg-muted/50 p-3"><div className="grid gap-3 md:grid-cols-2">
                <pre className="whitespace-pre-wrap font-mono text-[11px]"><b>Before</b>{"\n"}{JSON.stringify(l.before, null, 1)}</pre>
                <pre className="whitespace-pre-wrap font-mono text-[11px]"><b>After</b>{"\n"}{JSON.stringify(l.after, null, 1)}</pre></div></td></tr>}
            </Fragment>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
